import {RefreshCw} from 'lucide-react'
import AdminAuthGate from '@/components/admin/AdminAuthGate'
import AdminStats from '@/components/admin/AdminStats'
import LeadFilters from '@/components/admin/LeadFilters'
import LeadsTable from '@/components/admin/LeadsTable'
import LeadsPagination from '@/components/admin/LeadsPagination'
import { useFreightLeads } from '@/hooks/useFreightLeads'

function AdminDashboard() {
  const {
    leads, total, totalPages, loading, error, deleteLead, fetchLeads, fetchAllMatching,
    statsLeads, statsLoading,
    page, setPage, pageSize, setPageSize,
    sortKey, sortDir, toggleSort,
    search, setSearch,
    modeFilter, setModeFilter,
    cargoTypeFilter, setCargoTypeFilter,
    dateFrom, setDateFrom,
    dateTo, setDateTo,
    minRate, setMinRate,
    maxRate, setMaxRate,
    resetFilters, hasActiveFilters,
  } = useFreightLeads()

  return (
    <div className="min-h-screen bg-[#F1F5F9]">
      <header className="bg-[#1E293B] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-emerald-400">The Freight Calculator</p>
            <h1 className="mt-1 text-2xl font-bold">Freight Leads Dashboard</h1>
            <p className="mt-1 text-sm text-slate-300">Review, filter, and manage inbound B2B shipping quote requests.</p>
          </div>
          <button
            onClick={fetchLeads}
            className="inline-flex items-center gap-1.5 self-start sm:self-auto px-3 py-2 rounded-lg border border-white/20 text-sm font-medium text-white hover:bg-white/10 transition-colors"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            Refresh
          </button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <AdminStats leads={statsLeads} loading={statsLoading} />

        <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
          <LeadFilters
            search={search}
            onSearchChange={setSearch}
            modeFilter={modeFilter}
            onModeFilterChange={setModeFilter}
            cargoTypeFilter={cargoTypeFilter}
            onCargoTypeFilterChange={setCargoTypeFilter}
            dateFrom={dateFrom}
            onDateFromChange={setDateFrom}
            dateTo={dateTo}
            onDateToChange={setDateTo}
            minRate={minRate}
            onMinRateChange={setMinRate}
            maxRate={maxRate}
            onMaxRateChange={setMaxRate}
            hasActiveFilters={hasActiveFilters}
            onReset={resetFilters}
          />
        </div>

        {error ? (
          <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-center text-sm font-medium text-red-700">
            {error}
          </div>
        ) : (
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden">
            <LeadsTable
              leads={leads}
              loading={loading}
              sortKey={sortKey}
              sortDir={sortDir}
              onToggleSort={toggleSort}
              onDelete={deleteLead}
              onRefresh={fetchLeads}
              onExportAll={fetchAllMatching}
            />
            <LeadsPagination
              page={page}
              totalPages={totalPages}
              total={total}
              pageSize={pageSize}
              onPageChange={setPage}
              onPageSizeChange={setPageSize}
              currentCount={leads.length}
            />
          </div>
        )}
      </main>
    </div>
  )
}

function Admin() {
  return (
    <AdminAuthGate>
      <AdminDashboard />
    </AdminAuthGate>
  )
}

export default Admin
